import * as React from 'react';
import { SvcSessionsListTable } from './SvcSessionsListTable';
import DocumentTitle from '../../../misc/components/DocumentTitle';
import { ODataParams, Query } from '../../../Components/Query';
import { useCurrentStudyConfigurationContext } from '../../../Core/CurrentStudyConfigurationContext';
import { useWebPortalApiClient } from '../../../misc/api/WebPortalTokenClient';
import { QueryOfSvcSession } from 'webportalclient';

export const SvcSessionListScreen = () => {
    const { study } = useCurrentStudyConfigurationContext();
    const client = useWebPortalApiClient();

    const handleRefresh = async (params: ODataParams): Promise<QueryOfSvcSession> => {
        let filter = params.filter ? `(${params.filter}) and ` : '';
        filter += `visit/subject/site/studyId eq ${study.id}`;

        const constraints = 'analysisSets($select=type,status,analystUserName,id),tests($select=index),visit($expand=subject($expand=site($select=number,studyId)))';

        return await client.client.getSvcSessions(undefined, filter, params.orderby, constraints, params.top, params.skip, undefined, true);
    }

    return (
        <DocumentTitle title="SVC Sessions | Vitalograph Web Portal">
            <Query onRefresh={handleRefresh} initialOrdering={[{ field: "occurred", condition: "desc" }]}>
                <SvcSessionsListTable />
            </Query>
        </DocumentTitle>
    );
};
